import React, { FunctionComponent, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: React.ReactNode;
};
function componentActions(name: string): FunctionComponent<Props> {
  return function ComponentActions({ children }: Props): React.ReactPortal | null {
    const [isInDocument, setIsInDocument] = React.useState<boolean>(false);
    const timer = useRef<ReturnType<typeof setTimeout>>(null);
    const tries = useRef<number>(0);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
      checkInDocument();
    }, []);

    const checkInDocument = () => {
      clearTimeout(timer.current);
      if (tries.current > 10) {
        return;
      }
      const el = document.querySelector(`#${name}_header_actions`);
      if (el) {
        setIsInDocument(true);
        return;
      }

      setIsInDocument(false);
      tries.current = tries.current + 1;
      timer.current = setTimeout(checkInDocument, 50);
    };

    if (!isInDocument) {
      return null;
    }

    const el = document.querySelector(`#${name}_header_actions`);
    if (!el) {
      return null;
    }

    return createPortal(children, el);
  };
}

export { componentActions };
